import React from "react";
import { StyleSheet, Text, View, Image } from "react-native";
import { Button } from "react-native-elements";
import Theme from "./theme";
import HandleNotification from "../../notifications/push/handle";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
  }

  static navigationOptions = {
    header: null
  };

  render() {
    const { navigate } = this.props.navigation;

    return (
      <Theme>
        <View style={styles.container}>
          <View style={styles.image}>
            <Image
              style={{
                flex: 1,
                width: undefined,
                height: undefined,
                alignSelf: "stretch",
                resizeMode: "contain"
              }}
              source={require("../../../../assets/logo.png")}
            />
          </View>

          <View style={styles.optionContainer}>
            <Button
              title="CREATE GAME"
              onPress={() => navigate("CreateGame")}
            />
            <Button title="JOIN GAME" onPress={() => navigate("JoinGame")} />
          </View>
        </View>
        <HandleNotification {...this.props} />
      </Theme>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#44d9e6"
  },
  image: {
    flex: 3,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  },
  optionContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-evenly"
  }
});
